import { FontSizes } from './interfaces'

// values should be interpreted as rem
// rem base: 1rem = 16px

export const fontSizes: FontSizes = {
  xs: 10,
  s: 12,
  m: 14,
  l: 16,
  xl: 18,
  xxl: 32,
}
